import {FC} from "react";
import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import {Paragraph} from "../../../../lib/src/components/Paragraph";
import {SectionHeader} from "../../../../lib/src/components/content/SectionHeader";
import {Button} from "../../../../lib/src/components/form/Button";
import {faAdd} from "@fortawesome/free-solid-svg-icons";
import {useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import {ContentContainer} from "../../../../lib/src/components/content/ContentContainer";
import {FlowFilesTable} from "../../components/flowbuilder/FlowFilesTable";
import {FlowIndexTable} from "../../components/flowbuilder/FlowIndexTable";
import {AddFlowModal} from "../../modals/AddFlowModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export const FlowManagerPage: FC<{}> = () => {
  const {flows} = useApiCall(config)
  const flowsResource = useApiEndpoint(() => flows.listFlows())
  const flowFilesResource = useApiEndpoint(() => flows.listFlowFiles())

  const addFlowModal = useModal({title: 'Flow toevoegen', body: <AddFlowModal onFinish={() => {
    flowsResource.reload()
  }} />})

  return <ContentContainer size={'lg'}>
    <PageHeader>Flow Builder</PageHeader>
    <Paragraph>
      De Flow Builder is een tool waarmee je flows kan maken, bewerken en beheren. Een flow is een
      serie van stappen die automatisch worden uitgevoerd in een bepaalde volgorde. Dit kan bijvoorbeeld
      handig zijn voor het automatiseren van taken zoals het onboarden van nieuwe medewerkers.
    </Paragraph>

    <section className={'my-12'}>
      <div className={'flex justify-between items-end mb-4'}>
        <div className={'-mb-4'}><SectionHeader>Flows</SectionHeader></div>
        <Button type={'primary'} size={'sm'} text={'Nieuwe flow'} onClick={() => {
          addFlowModal.open()
        }} icon={faAdd} />
      </div>
      <FlowIndexTable isLoading={flowsResource.isLoading} flows={flowsResource.resource ?? []} />
    </section>

    <section className={'my-12'}>
      <div className={'flex justify-between items-end mb-4'}>
        <div className={'-mb-4'}><SectionHeader>Bestanden</SectionHeader></div>
        {/*<Button type={'primary'} size={'sm'} text={'Bestand toevoegen'} onClick={() => {*/}
        {/*  alert('TODO')*/}
        {/*}} icon={faUpload} />*/}
      </div>
      <Paragraph>
        Bestanden zijn binnen alle flows beschikbaar. Sommige acties kunnen hier gebruik van maken, zoals bijvoorbeeld
        het versturen van een e-mail, deze actie kan een bestand als bijlage meesturen.
      </Paragraph>

      <FlowFilesTable isLoading={flowFilesResource.isLoading} files={flowFilesResource.resource ?? []} />
    </section>
  </ContentContainer>
}